import styled from "styled-components";
import {
  greyDark,
  primaryHover,
  advancedPanelSliderWidth,
  lightInactive,
  md,
  grey,
  onHoverDropShadow,
} from "../variable";

/// TLDR Advanced panel
export const StyledAdvancedPanel = styled.div`
  -webkit-box-shadow: -8px 0 16px 0 ${onHoverDropShadow};
  -moz-box-shadow: -8px 0 16px 0 ${onHoverDropShadow};
  box-shadow: -8px 0 16px 0 ${onHoverDropShadow};
  position: fixed;
  z-index: 1;
  transition: width 0.75s ease;
  right: 0;
  top: ${(props) => props.top};
  width: ${advancedPanelSliderWidth};
  height: ${(props => props.height)};          
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background-color: ${greyDark};
  padding: 16px;
  overflow-y: auto;

  ::-webkit-scrollbar-track {
    background-color: transparent;
  }

  ::-webkit-scrollbar-track-piece {
    background-color: transparent;
  }

  .ql-toolbar,
  .ql-snow {
    padding: 0px;
  }

  .back {
    height: 100%;
    color: ${lightInactive};
    display: flex;
    align-items: center;

    :hover {
      color: ${primaryHover};
      cursor: pointer;
    }
  }

  .advanced-content {
    // margin-bottom: 4rem;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .advanced-header {
    display: flex;
    align-items: center;
    flex-direction: row;
    margin-bottom: 10px;

    .info {
      flex-grow: 1;
      display: block;
      @media (max-width: 768px) {
        display: none;
      }
    }

    @media (max-width: 768px) {
      margin-bottom: 0px;
      position: fixed;
      z-index: 3;
    }
  }

  @media (max-width: ${md}) {
    width: 100%;
    position: static;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
    // height: 100%;
    overflow: hidden;
    padding: 0px 24px;
  }

  .form-button {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    .btn-tprimary {
      width: 87%;
    }

    .btn-tprimary.generate-btn {
      width: 100%;
    }
  }
`;

export const StyledAdvancedSectionHeader = styled.div`
  font-size: 1.125rem;
  font-weight: 500;
  letter-spacing: 0.13px;
  line-height: 19px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  color: ${lightInactive};
  width: 100%;

  :hover {
    cursor: pointer;
  }

  div {
    svg {
      margin-right: 0.5rem;
    }
  }

  .subtitle {
    opacity: 0.7;
    text-transform: uppercase;
    color: ${grey};
    font-size: 0.7rem;
    font-weight: normal;
    letter-spacing: 0;
    line-height: 12px;
    margin-top: 2px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &.stripe-payment-history-title {
    font-size: 20px;

    svg {
      font-size: 16px;
    }
  }
`;

export const StyledColumnFlex = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledAdvancedSectionHeaderWithToggle = styled.div`
  display: flex;
  flex-direction: row;
`;

export const StyledTextEffectTitle = styled.div`
  text-align: center;
  // margin: 1rem;
  font-size: 1rem;
  letter-spacing: 0.1px;
  color: #888888;
  margin-top: 0rem;
`;

export const StyledCollapsibleSectionIconsRow = styled.div`
  display: flex;
  flex-direction: row;
`;

/// TLDR AI Editor panel
export const StyledAIEditorSidePanel = styled.div`
  -webkit-box-shadow: 0 8px 16px 0 ${onHoverDropShadow};
  -moz-box-shadow: 0 8px 16px 0 ${onHoverDropShadow};
  box-shadow: 0 8px 16px 0 ${onHoverDropShadow};
  z-index: 1000;
  transition: width 0.75s ease;
  ${(props) => `width: ${props.width}`};
  //height: calc(100% - 61px);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background-color: ${greyDark};
  padding: 0.5rem 1rem;
  overflow-y: auto;

  .ql-toolbar,
  .ql-snow {
    padding: 0px;
  }

  .back {
    height: 100%;
    color: ${lightInactive};
    display: flex;
    align-items: center;

    :hover {
      color: ${primaryHover};
    }
  }

  .advanced-content {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .advanced-header {
    display: flex;
    align-items: center;
    flex-direction: row;

    .info {
      flex-grow: 1;
    }
  }

  @media (max-width: ${md}) {
    width: 100%;
    position: static;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
    height: auto;
  }

  .form-button {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    .btn-tprimary {
      width: 100%;
    }
  }
`;
